import { render } from "./TermeniConditii.vue?vue&type=template&id=3af34274&scoped=true"
import script from "./TermeniConditii.vue?vue&type=script&lang=js"
export * from "./TermeniConditii.vue?vue&type=script&lang=js"

import "./TermeniConditii.vue?vue&type=style&index=0&id=3af34274&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3af34274"]])

export default __exports__